/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import dayjs from "dayjs";
import {classToPlain} from "class-transformer";
import BaseIdObject from "@shared/BaseIdObject";
import {asArray} from "@/utils/helpers";

export default class DbBaseObject extends BaseIdObject{

	createdAt : number = null;
	updatedAt : number  = null;
	schemaVersion: number = 1 // for newly crated objects, the latest schema version is only applied during beforeSaveToDb

	_isSchemaMigrated: boolean = false
	_schemaMigratedFrom: number = -1
	_schemaMigratedTo: number = -1

	_createdAtFormatted: string = ""
	_updatedAtFormatted: string = ""




	constructor(options = {}) {
		super(options)
		this.resetObject()
	}


	getCurrentSchemaVersion(){
		return this.schemaVersion
	}

	resetObject() {
		super.resetObject();
		this.setCreatedAtNow()
	}

	setCreatedAtNow(){
		this.createdAt = new Date().getTime()
	}


	createdAtFormatted(format){
		format = format || "MMM DD, YYYY"
		return dayjs(this.createdAt).format(format)
	}

	assignId(firebaseCollection): string{
		if(!this.id){
			let ref = firebaseCollection.doc();
			this.id = ref.id
		}
		return this.id;
	}

	asJsonObject(): any {
		return classToPlain(this, { excludePrefixes: ["_"] })
	}

	asDbJson(): any {
		let json = this.asJsonObject();
		json = this.beforeSaveToDbOld(json)
		return json;
	}

	beforeSaveToDbOld(json: any): any{
		return json;
	}

	beforeSaveToDb(options = {}){
		console.log("beforeSaveToDb: options = ", options, this)
		let {skipUpdateUpdatedAt} = options
		if(!skipUpdateUpdatedAt){
			this.updatedAt = new Date().getTime()
		}
		if(this.schemaVersion === 1){
			//here we make sure that newly created objects have the most recent schema version
			//for objects loaded from the database this logic won't have any affect, because migrateSchema is applied during fetch and the latest version is set then
			this.schemaVersion = this.getCurrentSchemaVersion()
		}
		if(typeof this.syncSyncableProps === "function"){
			this.syncSyncableProps()
		}
	}




	assignIdArray(array, fbCollection = null){
		if(fbCollection){
			array.forEach(item => {
				item.assignId(fbCollection)
			})
		}
	}

	addIds(objectIds, targetArray){
		objectIds = asArray(objectIds)

		objectIds.forEach(objectId => {
			let hasItem = targetArray.some(item => item == objectId)
			if(objectId && !hasItem){
				targetArray.push(objectId)
			}
		})
	}
	removeIds(objectId, targetArray = []){
		let newOwnerIds = []

		targetArray.forEach(ownerId => {
			if(ownerId != objectId){
				newOwnerIds.push(ownerId)
			}
		})
		targetArray.removeAllElements()
		targetArray.push(...newOwnerIds)
	}

	removeOwnersAll(){
		this.ownerIds = this.ownerIds || []
		this.ownerIds.removeAllElements()
	}

	addOwner(objectIds){
		this.ownerIds = this.ownerIds || []
		this.addIds(objectIds, this.ownerIds)
	}
	removeOwner(objectId){
		this.ownerIds = this.ownerIds || []
		this.removeIds(objectId, this.ownerIds)
	}

	isOwner(objectId){
		this.ownerIds = this.ownerIds || []
		let isOwner = this.ownerIds.some(item => item == objectId)
		// console.log("isOwner: ", isOwner, ", objectId = ", objectId, ", this.ownerIds = ", this.ownerIds)
		return isOwner
	}

	// for firestore case folding to orderBy in case insensitive way
	// https://stackoverflow.com/a/48098215/1713920
	caseFoldNormalize(s){
		if(!s){
			return s
		}
		return s.normalize('NFKC').toLowerCase().toUpperCase().toLowerCase()
	}


	startSchemaMigration(){
		let newVersion = this.getCurrentSchemaVersion()
		let oldVersion = this.schemaVersion
		if(oldVersion < newVersion){
			console.log("startSchemaMigration: oldVersion = ", oldVersion, ", newVersion = ", newVersion, ", this = ", this)
			this.migrateSchema(oldVersion, newVersion)
			this.schemaVersion = newVersion
			this._isSchemaMigrated = true
			this._schemaMigratedFrom = oldVersion
			this._schemaMigratedTo = newVersion
			return true
		}
		return false
	}



	migrateSchema(oldVersion, newVersion) {
	}

	isSchemaMigrated(){
		return this._isSchemaMigrated
	}
	isSchemaMigratedToOrAbove(targetSchemaVersion){
		return this.isSchemaMigrated() && this._schemaMigratedFrom < targetSchemaVersion && targetSchemaVersion <= this._schemaMigratedTo
	}

	onLoadedFromDb(){
		this.setupDebugData()
		// recursive onLoadedFromDb
		// Commented out for performance reasons as we don't really need it now

		// console.log("onLoadedFromDb ", this)
		// Object.keys(this).forEach(key => {
		// 	let obj = this[key]
		// 	if(obj instanceof DbBaseObject){
		// 		obj.onLoadedFromDb()
		// 	} else if(Array.isArray(obj)){
		// 		obj.forEach(item => {
		// 			if(item instanceof DbBaseObject) {
		// 				item.onLoadedFromDb()
		// 			}
		// 		})
		// 	}
		// })

	}

	setupDebugData(){
		let formatFull = "MMM DD, YYYY, h:mm:ss a"
		this._createdAtFormatted = this.createdAtFormatted(formatFull)
		this._updatedAtFormatted = this.createdAtFormatted(formatFull)
	}

}
